import { createRequest } from '@savgroup-front-common/core/services/request';

export enum REPAIRER_ACTION_TYPE {
  GET_REPAIRERS_BY_TYPE_AND_SELLER_ID = 'REPAIRER/GET_REPAIRERS_BY_TYPE_AND_SELLER_ID',
}

export const GET_REPAIRERS_BY_TYPE_AND_SELLER_ID = createRequest(
  REPAIRER_ACTION_TYPE.GET_REPAIRERS_BY_TYPE_AND_SELLER_ID,
);
